import { FieldBehaviour } from "../../config/fieldBehaviours";
import { FieldValidator } from "../../config/fieldValidators";
import { LookupOptionFilter } from "../../config/lookupOptionFilters";

const TwoHours = 2 * 60 * 60 * 1000;

const toDate = (value: unknown) => {
  if (!value) {
    return null;
  }

  const date = new Date(value as string);

  return Number.isNaN(date.getTime()) ? null : date;
};

const pad = (n: number) => String(n).padStart(2, "0");

// Local time with no zone, as the fixture's start and end are stored.
const toLocalValue = (date: Date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

const sameDay = (a: Date, b: Date) => a.toDateString() === b.toDateString();

/**
 * A new start keeps the end when it is still later the same day; otherwise the end
 * moves to two hours after the start, as the legacy form did.
 */
const fixtureEndFromStart: FieldBehaviour = (value, values) => {
  const start = toDate(value);
  const end = toDate(values.fixtureend);

  if (!start) {
    return values.fixtureend;
  }

  return end && end > start && sameDay(end, start)
    ? values.fixtureend
    : toLocalValue(new Date(start.getTime() + TwoHours));
};

const fixtureEndAfterStart: FieldValidator = (value, record) => {
  const end = toDate(value);
  const start = toDate(record.fixturestart);

  return !end || !start || end > start ? "" : "Select a later date";
};

/** The chosen opponent's fixtures, never the fixture itself. */
const lastSeasonFixture: LookupOptionFilter = (options, record) =>
  options.filter(
    (option) =>
      (!record.opponentid ||
        String(option.OpponentId) === String(record.opponentid)) &&
      (!record.id || String(option.Key) !== String(record.id))
  );

export const fixtureBehaviours = { fixtureEndFromStart };
export const fixtureValidators = { fixtureEndAfterStart };
export const fixtureOptionFilters = { lastSeasonFixture };
